module.exports = __webpack_public_path__ + "img/home_img_12.02115cf8.png";